import { Components, Theme } from "@mui/material";

export const MuiFormControlLabel: Components<Theme>["MuiFormControlLabel"] = {
  styleOverrides: {
    root: ({ theme }) => {
      return {
        ...theme.typography.formLabel,
        "& .MuiFormLabel-asterisk": {
          color: theme.palette.warning.main,
        },
      };
    },
    label: ({ theme }) => {
      return {
        ...theme.typography.formLabel,
        "& .MuiFormLabel-asterisk": {
          color: theme.palette.warning.main,
        },
      };
    },
  },
};
